<script lang="ts">
  import type {Splide as SplideInstance} from "@splidejs/splide";
  import {Splide, SplideSlide, SplideTrack} from "@splidejs/svelte-splide";
  import BonusOfferItem from "$lib/components/ModalContents/DepositWithdraw/Deposit/BonusOfferItem.svelte";
  import {createEventDispatcher} from "svelte";
  import ArrowRightIcon from "$lib/icons/ArrowRightIcon.svelte";
  import type {IDepositOffer} from "$lib/interfaces/IDepositOffer";
  import {userService} from "$lib/services/user.service";

  interface Props {
    type?: 'CRYPTO' | 'FIAT';
  }

  let { type = 'FIAT' }: Props = $props();
  let splide: SplideInstance = $state();
  let dispatch = createEventDispatcher();

  let splideOptions = {
    type: 'slide',
    loop: false,
    perPage: 1,
    perMove: 1,
    gap: '1rem',
    autoplay: false,
    pagination: false,
    rewind: true,
    lazyLoad: false,
    drag: true,
    padding: {
      left: '0px',
      right: '24px',
    },
    arrows: false,
  };
  let currentSlide = $state(0);
  let depositOffers: IDepositOffer[] = $state([]);
  let promise = getDepositOffers();


  async function getDepositOffers() {
    await userService.getDepositBonusOffer(type).then((response: any) => {
      if (response) {
        return response.data;
      }
      throw new Error('Failed to fetch deposit offers');
    }).then(data => {
      depositOffers = data.data;
      return depositOffers;
    }).catch(err => {
      console.error(err);
    });
  }


  function onMounted(event: CustomEvent<{ splide: SplideInstance }>) {
    splide = event.detail.splide;
    splide.on('moved', () => {
      splide.refresh()
    });
  }

  function offerActivated(e: any) {
    dispatch('offerActivated', e.detail);
  }
</script>

<div class="mb-6">
  <div class="flex justify-between">
    <h3 class="text-white text-lg my-4">Deposit Offers</h3>

    <div class="splide__arrows flex items-center gap-2">
      <button onclick={() => splide.go('<')} class="custom-arrow border-2 border-primary-lightBlue rounded-full hover:bg-primary-lightBlue">
        <ArrowRightIcon css="rotate-180" />
      </button>
      <button onclick={() => splide.go('>')} class="custom-arrow border-2 border-primary-lightBlue rounded-full hover:bg-primary-lightBlue">
        <ArrowRightIcon />
      </button>
    </div>
  </div>
  {#await promise}
    <div>
      <div class="text-white text-center">Loading...</div>
    </div>
  {:then data}
    {#if depositOffers.length > 0}

      <Splide on:mounted={onMounted} on:moved={(e) => currentSlide = e?.detail?.index ?? 0} aria-label="DepositOfferList" options="{splideOptions}" >
        {#each depositOffers as item}
          <SplideSlide>
            <BonusOfferItem on:offerActivated={(e) => offerActivated(e)} {item} />
          </SplideSlide>
        {/each}
      </Splide>
    {:else}
      <div class="text-white text-center">No offers available</div>
    {/if}
    <ul class="splide__pagination mb-2 gap-3">
      {#each depositOffers as item, i}
        <li class="splide__pagination__page {i === currentSlide ? 'bg-primary-yellow !w-4 !h-4' : '!w-3 !h-3'}">
          <button onclick={() => splide.go(i)} class="{i === currentSlide ? '!w-4 !h-4' : '!w-3 !h-3'}"></button>
        </li>
      {/each}
    </ul>
  {:catch error}
    <div class="text-white text-center">No offers available</div>
  {/await}
</div>

<style lang="scss">
  .custom-arrow {
    padding: 6px;
    transition: transform 0.2s, stroke 0.2s;
  }

  .custom-arrow:active {
    transform: scale(0.9); /* Scale down on click */
  }
</style>
